/**
 * React Query hook for investor portal recent activity
 */

import { useApiQuery } from '@/hooks/react-query/useApiQuery';
import { portalQueryKeys } from '@/portal/shared/hooks/queryKeys';
import { investorPortalApiClient } from '@/portal/shared/utils/api-client';

export interface RecentActivityItem {
  id: string;
  type: string;
  date: string;
  fund_name: string;
  description: string;
  amount: number;
  currency: string;
  status: string;
}

/**
 * Hook to fetch recent activity for the investor dashboard
 */
export const useRecentActivity = () => {
  return useApiQuery<RecentActivityItem[]>(
    portalQueryKeys.dashboard.recentActivity(),
    () =>
      investorPortalApiClient.get<RecentActivityItem[]>(
        '/portal/dashboard/recent-activity'
      ),
    {
      staleTime: 2 * 60 * 1000, // 2 minutes
    }
  );
};
